interface PolicyTesterParamsBase {
  url: string
  emailId: string
  emailType: string
}

export type UsePolicyTesterMutationParams = PolicyTesterParamsBase
export type GetPolicyTesterAPIParams = PolicyTesterParamsBase

export interface PolicyTesterClashingPolicy {
  policyName: string
  groupName: string
}

export enum PolicyTesterCheckEnum {
  SHADOW_IT_CHECK = 'SHADOW_IT_CHECK',
  LOCAL_IP_BYPASS_CHECK = 'LOCAL_IP_BYPASS_CHECK',
  BYPASS_CHECK = 'BYPASS_CHECK',
  CAC_CHECK = 'CAC_CHECK',
  CUSTOM_CATEGORY_CHECK = 'CUSTOM_CATEGORY_CHECK',
  DOPE_CATEGORY_CHECK = 'DOPE_CATEGORY_CHECK',
}

export enum PolicyTesterStatusEnum {
  ALLOW = 'ALLOW',
  BLOCK = 'BLOCK',
  WARN = 'WARN',
  BYPASS = 'BYPASS',
}

export type PolicyTesterEmailType = 'user' | 'group'

export interface PolicyTesterCategoryListItem {
  name: string
  state: PolicyTesterStatusEnum
}

interface PolicyTesterPolicyData {
  name: string
  clashingPolicies?: PolicyTesterClashingPolicy[]
}

interface PolicyTesterDecisionData {
  action: PolicyTesterStatusEnum
  check: PolicyTesterCheckEnum
  reason: string
  details?: PolicyTesterDecisionDetailsData
}

interface PolicyTesterDecisionDetailsData {
  mostRestrictiveCategory?: string
  leastRestrictiveCategory?: string
  categories: PolicyTesterCategoryListItem[]
}

export interface PolicyTesterResponse {
  policy: PolicyTesterPolicyData
  decision: PolicyTesterDecisionData
}
